import { useIntl, getTranslatedText } from '@nile/components';

export default {
  expiryQty: {
    presence: {
      allowEmpty: false,
      message: () => {
        const intl = useIntl();
        return `^${getTranslatedText(intl, 'common.choose.expiry')}`;
      }
    },
    numericality: {
      greaterThan: 0,
      message: () => {
        const intl = useIntl();
        return `^${getTranslatedText(intl, 'common.choose.expiry')}`;
      }
    }
  }
};
